export class AppRouteConfig {
  public title: string;
  public fullPath: string;
  public childPath?: string;
}
